import { PATH } from '../../../data/router_path'
import AccountListPerBorrowBook from '../../../features/book-management/book-borrow/AccountsBorrowDataTable'
import { useParams } from 'react-router-dom'
import BookFilterHeader from '../../../features/book-management/book-list/BookFilterHeader'
import { useEffect } from 'react'
export default function UsersListPerBorrowBook() {
  const { uuid } = useParams()
  const path = PATH.BOOK.BORROWERS_PER_BOOK(uuid)
  const Data = localStorage.getItem('borrowBookInfo')
  localStorage.setItem('isBorrowBookInfo', Data)
  const rawData = localStorage.getItem('isBorrowBookInfo')
  let titleBookBorrow = ''

  if (rawData) {
    try {
      const dataBookBorrow = JSON.parse(rawData)
      titleBookBorrow = dataBookBorrow[0]?.titleBorrow || 'Không có nhan đề'
    } catch (error) {
      console.error('Error parsing isBorrowBookInfo:', error)
    }
  }
  useEffect(() => {
    return () => {
      localStorage.removeItem('isBorrowBookInfo')
    }
  }, [])
  useEffect(() => {
    const handleClearData = () => {
      localStorage.removeItem('isBorrowBookInfo')
    }
    window.addEventListener('beforeunload', handleClearData)
    return () => {
      window.removeEventListener('beforeunload', handleClearData)
    }
  }, [])
  if (!uuid) return null
  return (
    <>
      <BookFilterHeader
        title={'Danh sách sinh viên đang mượn'}
        path={path}
        titleBookBorrow={titleBookBorrow}
      />
      <AccountListPerBorrowBook path={path} uuidBook={uuid} />
    </>
  )
}
